import React, { FC, useEffect, useState, useMemo } from "react";
import { Tabs, Button, Select, Avatar, Spin, Empty, Popover, Tooltip } from "antd";
import moment from "moment";
import { cloneDeep, forEach, noop, uniqBy, clone, find, debounce } from "lodash";
import { CloseCircleOutlined } from "@ant-design/icons";
// @ts-ignore
import Masonry from "react-responsive-masonry";
import { VariableSizeList as List } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";
import { useLocation } from "react-router-dom";

import NotesCard from "@components/drawerNotes/notes";
import "./drawerNotes.scss";
import { colors, DataOptions, tabs, TNotesProps, titles } from "./constant";
import membersService from "@services/members.service";
import PatientProfileService from "@services/patientProfile.service";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import Icon from "@assets/icon_config";
import { CanEdit } from "@components/accessLevel";
import {
  MEMBERS_DETAILS_SCREEN_TITLE,
  MEMBERS_SCREEN_TITLE,
  MEMBER_DETAILS_LOCAL,
  MEMBER_LIST_GLOBAL,
  USER_ACTION_DESCRIPTION_NOTE_DELETE,
  USER_ACTION_DESCRIPTION_NOTE_SAVE,
  USER_ACTION_MODULE_MEMBER_LIST,
  USER_ACTION_TAB_GLOBAL,
  USER_ACTION_CARD_RIGHT_NAVIGATION,
  USER_ACTION_LOCATION_DEFAULT,
  USER_ACTION_DESCRIPTION_NOTE_BOOKMARK,
  USER_ACTION_MODULE_MEMBER_DETAIL,
  USER_ACTION_DESCRIPTION_NOTE_UPDATE,
  CASE_STATUS_REASON_NOTE,
} from "@utils/constants";
// import RichTextEditorComp from "@components/richTextEditor/richText";
import { centricClientCheck, formatDisplayDate, getNoteMaxLength } from "@utils/helpers";
import { useRTEState } from "@components/richTextEditor/useRTEState";
import useSession from "@utils/useSession";
import RichTextEditor from "@components/richTextEditor";
//import { IMembers } from "@pages/members/constants";
import DataNotFound from '@components/noDataFound'
import { NO_DATA_AVAILABLE, NO_DATA_FOUND } from "../../constants/constants";
import { useMemberListStore } from "@stores/useMemberListStore";

const text = "";

const { TabPane } = Tabs;

const Notes: FC<TNotesProps> = ({ members, updateMembers, searchValue, filterValue, updateStatus, filterStartDate, filterEndDate, defaultTab, setDefaultTab, rightDrawerCloseHandler }) => {
  const { bookmarkStatus, setBookmarkStatus, recipientType, setRecipientType, prevBookmarkStatus, setPrevBookmarkStatus, recipientValue } = useRTEState();
  //Store State
  const currentScreen = useGlobalInformationStore((state) => state.currentScreen);
  const updatedNotes = useCareCoordinationStore((state) => state.updatedNotes);
  const setUpdatedNotes = useCareCoordinationStore((state) => state.setUpdatedNotes);
  const globalPatientList = useGlobalInformationStore((state) => state.globalPatientList);
  const globalPatientListLoader = useGlobalInformationStore((state) => state.globalPatientListLoader);

  const [notesData, setNotesData] = useMemberListStore((state) => [state.notesData, state.setNotesData]);
  const [notesHeights, setnotesHeights] = useState<any>([]);
  const [copyNotes, setCopyNotes] = useState<any>([]);
  const [showNoteLayer, newNoteLayerHandle] = useState(false);
  const [selectedMembers, selectedMembersHandler] = useState<any>([]);
  const [content, setContent] = useState(text);
  const [addLoader, setAddLoader] = useState(false);
  const [loaderForAllNotes, setLoaderForAllNotes] = useState(false);
  const [membersOptions, setMembersOptions] = useState<any>(globalPatientList);
  const [noteEditor, setNoteEditor] = useState(false);
  const [noteEditState, setNoteEditState] = useState(false);
  const [editNoteData, setEditNoteData] = useState<any>();
  const [fetchingPatientList, setFetchingPatientList] = useState<boolean>(false);
  const [selectedPatientObject, setSelectedPatientObject] = useState<any>([]);
  const [editMode, setEditMode] = useState<any>(false);
  const [searchMembersInputString, setSearchMembersInputString] = useState<any>(null);
  const [page, setPage] = useState<any>(1);
  const [height, setheight] = useState<number>();
  const [filters, setFilters] = useState<any>(null);
  const location = useLocation();
  const session = useSession();
  const notesWordLimit = getNoteMaxLength();
  const shouldShowCustomControls = true;
   const memberStatus = membersService?.getCurrentMember?.patient_status
  const isMemberActive = memberStatus === "Active"
  const isDisabled = centricClientCheck() && currentScreen === MEMBERS_DETAILS_SCREEN_TITLE  && !isMemberActive;

  const isAllCM = useMemo(() => {
    return location.pathname === "/member-detail";
  }, [location.pathname]);

  const memberId = useMemo(() => {
    return isAllCM ? members[0]?.patient_id : undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllCM, members[0]?.patient_id]);

  const getUserActionParams = (userActionDescription: any, reason: any) => {
    let props;
    switch (currentScreen) {
      case MEMBERS_SCREEN_TITLE:
        props = {
          caseStatusReasonTxt: reason,
          actionModule: USER_ACTION_MODULE_MEMBER_LIST,
          actionTab: USER_ACTION_TAB_GLOBAL,
          actionCard: USER_ACTION_CARD_RIGHT_NAVIGATION,
          actionLocation: USER_ACTION_LOCATION_DEFAULT,
          actionDescription: userActionDescription,
        };
        break;
      case MEMBERS_DETAILS_SCREEN_TITLE:
        props = {
          caseStatusReasonTxt: reason,
          actionModule: USER_ACTION_MODULE_MEMBER_DETAIL,
          actionTab: USER_ACTION_TAB_GLOBAL,
          actionCard: USER_ACTION_CARD_RIGHT_NAVIGATION,
          actionLocation: USER_ACTION_LOCATION_DEFAULT,
          actionDescription: userActionDescription,
        };
        break;
      default:
        props = {};
    }

    return props;
  };

  const computeFilteredDate = (date: any, type: any) => {
    if (type === "startDate") {
      return moment.utc(moment(`${date} 00:00:00`).utc());
    } else if (type === "endDate") {
      return moment.utc(moment(`${date} 23:59:59`).utc());
    }
  };

  useEffect(() => {
    if (ref) {
      ref.resetAfterIndex(0, true);
    }
  }, [notesData]);

  const onNoteShowMore = (index: number, isShowMore: boolean) => {
    if (notesData) {
      let notes = clone(notesData);
      notes.notes[index].isShowMore = isShowMore;
      setNotesData(notes);
    }
  };

  const getNotesForPage = (page: any, filter: any, activeTab: any, clear: boolean) => {
    setLoaderForAllNotes(true);
    const computedFilter = {
      ...filter,
      startDate: computeFilteredDate(filter?.startDate, "startDate"),
      endDate: computeFilteredDate(filter?.endDate, "endDate"),
    };
    membersService.getNotesForPage({ isAllCM, memberId, page: page, filter: computedFilter }).subscribe({
      next: (res) => {
        let notes = res?.data?.data?.notes.map((note: any) => {
          note.isBookMarked = note.isBookMarked === "N" ? false : true;
          note.recipientType = note.recipientType === "PCP" ? true : false;
          return note;
        });
        const notesFilteredArray = uniqBy([...(notesData?.notes && !clear ? notesData?.notes : []), ...(notes ? notes : [])], "notesId");
        // notes = [...(notesData?.notes ? notesData?.notes : []), ...(notes ? notes : [])]
        const currentPageLength = activeTab === "1" ? res?.data?.data?.bookMarkedTotalCount : res?.data?.data?.allNotesTotalCount;
        setNotesData({ ...res?.data?.data, notes: notesFilteredArray, currentPageLength });
        setLoaderForAllNotes(false);
      },
      error: (err) => {
        setLoaderForAllNotes(false);
      },
    });
  };

  const loadNextNotes = () => {
    if (notesData?.notes?.length < notesData?.currentPageLength) {
      const nextPage: number = page + 1;
      setPage(nextPage);
      const filter = {
        ...filters,
        isBookMarked: defaultTab === "1" ? true : false,
      };
      setFilters(filter);
      getNotesForPage(nextPage, filter, defaultTab, false);
    }
  };

  const bookmarkClickHandler = (data: DataOptions) => {
    //Handling for global Note
    let ccNotes = [...cloneDeep(notesData?.notes ? notesData?.notes : [])].map((item: any) => {
      if (item.notesId === data.notesId) {
        item.isBookMarked = !item.isBookMarked;
      }
      return item;
    });

    const bookMarkedNote = find(ccNotes, { notesId: data?.notesId });

    // Handling for member table notes
    const copyMembers = [...members];
    copyMembers.forEach((mem) => {
      if (mem.patient_id === data.patientId) {
        mem.notes.forEach((item: any) => {
          if (item.notesId === data.notesId) {
            item.isBookMarked = notesData?.notes?.find((note: any) => note.notesId === data.notesId).isBookMarked;
          }
        });
        const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(USER_ACTION_DESCRIPTION_NOTE_BOOKMARK, CASE_STATUS_REASON_NOTE);
        updateStatus(mem, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription);
      }
    });
    updateMemberList(copyMembers);

    if (currentScreen === MEMBERS_DETAILS_SCREEN_TITLE) {
      let tempUpdatedNotes = cloneDeep(updatedNotes);
      let isUpdatednoteExists = false;
      forEach(updatedNotes.editedNotes, (note, index) => {
        if (Number(note.notesId) === Number(data.notesId)) {
          isUpdatednoteExists = true;
          tempUpdatedNotes.editedNotes[index] = {
            ...note,
            ...data,
          };
        }
      });
      if (!isUpdatednoteExists) tempUpdatedNotes.editedNotes.push(data);
      setUpdatedNotes(tempUpdatedNotes);
    }

    if (defaultTab === "1") {
      ccNotes = ccNotes?.filter?.((item: any) => item.notesId !== data.notesId);
    }
    setNotesData({
      ...(notesData ? notesData : {}),
      bookMarkedTotalCount: bookMarkedNote?.isBookMarked ? notesData?.bookMarkedTotalCount + 1 : notesData?.bookMarkedTotalCount - 1,
      currentPageLength: defaultTab === "1" ? (bookMarkedNote?.isBookMarked ? notesData?.bookMarkedTotalCount + 1 : notesData?.bookMarkedTotalCount - 1) : notesData?.currentPageLength,
      notes: ccNotes,
    });
  };

  const deleteHandler = (notesId: any, setDeleteLoader: any) => {
    membersService.deleteNotes(notesId).subscribe({
      next: () => {
        let data = [...cloneDeep(notesData?.notes ? notesData?.notes : [])];
        const deletedNotes = find(data, { notesId: notesId });
        let updated = cloneDeep(data).filter((item: any) => {
          return item.notesId !== notesId;
        });

        const patientId = data.find((note) => note.notesId === notesId).patientId;
        let copyMembers = [...members];
        let memberIndex: any;
        let noteIndex: any;
        copyMembers.forEach((mem, i) => {
          if (mem.patient_id === patientId) {
            memberIndex = i;
            mem.notes.forEach((item: any, j: any) => {
              if (item.notesId === notesId) {
                noteIndex = j;
              }
            });
            const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(USER_ACTION_DESCRIPTION_NOTE_DELETE, CASE_STATUS_REASON_NOTE);
            updateStatus(mem, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription);
          }
        });
        if (memberIndex >= 0) {
          copyMembers[memberIndex].notes.splice(noteIndex, 1);
          updateMemberList(copyMembers);
        }
        setDeleteLoader(false);

        if (currentScreen === MEMBERS_DETAILS_SCREEN_TITLE) {
          let tempUpdatedNotes = cloneDeep(updatedNotes);
          tempUpdatedNotes.deletedNotes.push(Number(notesId));
          setUpdatedNotes(tempUpdatedNotes);
        }

        setNotesData({
          ...(notesData ? notesData : {}),
          allNotesTotalCount: notesData?.allNotesTotalCount ? notesData?.allNotesTotalCount - 1 : 0,
          bookMarkedTotalCount: deletedNotes?.isBookMarked ? (notesData?.bookMarkedTotalCount ? notesData?.bookMarkedTotalCount - 1 : 0) : notesData?.bookMarkedTotalCount,
          currentPageLength: defaultTab === "1" ? (notesData?.bookMarkedTotalCount ? notesData?.bookMarkedTotalCount - 1 : 0) : notesData?.allNotesTotalCount ? notesData?.allNotesTotalCount - 1 : 0,
          notes: updated,
        });
      },
      error: () => {
        setDeleteLoader(false);
      },
    });
  };

  const [ref, setref] = useState<any>();

  const getNotesCard = (item: any) => {
    const lazyNoteCard: any = (props: any) =>
      notesData?.notes[props.index] ? (
        <div style={props.style}>
          <>
            <NotesCard
              key={`note_${props.index}`}
              data={notesData?.notes[props.index]}
              width="100%"
              className="notesCard"
              avatarSize={20}
              bookmarkClickHandler={bookmarkClickHandler}
              noteEditor={noteEditor}
              setNoteEditState={setNoteEditState}
              membersChangeHandler={membersChangeHandler}
              setContent={setContent}
              deleteHandler={deleteHandler}
              setEditNoteData={setEditNoteData}
              setMembersOptions={setMembersOptions}
              setEditMode={setEditMode}
              setBookmarkStatus={setBookmarkStatus}
              setPrevBookmarkStatus={setPrevBookmarkStatus}
              setRecipientType={setRecipientType}
              tab={item.key}
              onShowMore={(isShowMore: boolean) => {
                onNoteShowMore(props.index, isShowMore);
              }}
              rightDrawerCloseHandler={rightDrawerCloseHandler}
            />
          </>
        </div>
      ) : null;

    return (
      <Spin spinning={loaderForAllNotes} indicator={<HealthemSpinner size={45} />}>
        {notesData?.notes?.length === 0 ? (
          <DataNotFound message={NO_DATA_AVAILABLE}/>
        ) : (
          <div className="allNotes__container">
            {height && (
              <InfiniteLoader
                isItemLoaded={(index) => index < notesData?.notes?.length}
                itemCount={notesData?.notes?.length < notesData?.currentPageLength ? notesData?.notes?.length + 1 : notesData?.notes?.length}
                loadMoreItems={() => loadNextNotes()}
                threshold={1}
              >
                {({ onItemsRendered, ref, index }: any) => {
                  return (
                    <List
                      ref={(ref) => setref(ref)}
                      height={height}
                      width={"100%"}
                      itemCount={notesData?.notes?.length < notesData?.currentPageLength ? notesData?.notes?.length + 1 : notesData?.notes?.length}
                      itemSize={
                        (index) => {
                          let note = notesData?.notes[index];
                          let card = document.querySelector(`.ant-tabs-tabpane-active #drawer_note_card_${item?.key}_${note?.notesId}`);
                          // console.log(card)
                          return note?.isShowMore ? (card?.clientHeight ? card?.clientHeight + 50 : 0) || 350 : (card?.clientHeight ? card?.clientHeight + 25 : 0) || 160;
                        }
                        // (notesHeights && notesHeights[index]) || 140
                      }
                      onItemsRendered={onItemsRendered}
                      // ref={ref}
                    >
                      {lazyNoteCard}
                    </List>
                  );
                }}
              </InfiniteLoader>
            )}
          </div>
        )}
      </Spin>
    );
  };

  const getMembersList = (inputString: string) => {
    const searchPatient = inputString?.trim();
    setSearchMembersInputString(searchPatient);
    if (searchPatient.length > 2) {
      setFetchingPatientList(true);
      PatientProfileService.fetchPatientsList({ patient_name: searchPatient }).subscribe({
        next: (v) => {
          let response = v?.data?.data;
          setMembersOptions(response);
          setFetchingPatientList(false);
        },
        error: (e) => {
          console.log(e);
          setFetchingPatientList(false);
        },
      });
    } else {
      setMembersOptions([]);
    }
  };

  const debouncedMemberSearch = debounce(getMembersList, 500);

  const onSelectMemberChangeHandler = (selectedValue: any) => {
    // setMembersOptions([]);
    // setSelectedPatientObject([]);

    if (selectedMembers.length === 0) {
      selectedMembersHandler(selectedValue);
      setSelectedPatientObject(membersOptions?.filter((option: any) => option?.patient_id === selectedValue[0]));
    } else {
      if (selectedMembers?.filter((option: any) => option === selectedValue[0])?.length === 0) {
        selectedMembersHandler([...selectedMembers, ...selectedValue]);
        setSelectedPatientObject([...selectedPatientObject, ...membersOptions?.filter((option: any) => option?.patient_id === selectedValue[0])]);
      }
    }
  };

  const onRemoveSelectedMembers = (memberId: any) => {
    //selected members has to be updated and selectedPatient Object
    // selectedMembersHandler selectedMembers
    // setSelectedPatientObject selectedPatientObject
    selectedMembersHandler(selectedMembers?.filter((filteredId: any) => filteredId !== memberId));
    setSelectedPatientObject(selectedPatientObject?.filter((filteredPatient: any) => filteredPatient.patient_id !== memberId));

    console.log(" member removed : " + memberId);
  };

  const popOverSelectedMembers = () =>
    selectedPatientObject?.slice(2)?.map((selectedMembers: any, index: any) => {
      return (
        <div className="selected-members-pop-over">
          <span className="selected-members-pop-over__member-detail">
            {/* <Avatar
              className="selected-members-pop-over__member-detail__avatar"
              style={{
                background: index > colors.length - 1 ? colors[0] : colors[index],
              }}
            >
              {selectedMembers?.patient_name?.charAt(0)}
            </Avatar> */}

            <span className="selected-members-pop-over__member-detail__name">{selectedMembers?.patient_name}</span>
          </span>
          <span className="selected-members-pop-over__close" onClick={() => onRemoveSelectedMembers(selectedMembers?.patient_id)}>
            <Icon name={"close"} />
          </span>
        </div>
      );
    });

  const clearAllSelectedMembers = () => {
    selectedMembersHandler([]);
    setSelectedPatientObject([]);
    setMembersOptions([]);
  };

  const tabsChangeHandler = (activeKey: string) => {
    setDefaultTab(activeKey);
    activeKey === "2" ? setNoteEditor(true) : setNoteEditor(false);
    setPage(1);
    const filter = {
      ...filters,
      isBookMarked: activeKey === "1" ? true : false,
    };
    setFilters(filter);
    getNotesForPage(1, filter, activeKey, true);
  };

  const showNewNote = () => {
    if (!editMode && currentScreen !== MEMBERS_DETAILS_SCREEN_TITLE) {
      setMembersOptions([]);
    }
    newNoteLayerHandle(true);
    defaultMemberSelection();
  };

  const membersChangeHandler = (selectedItems: any) => {
    //if current page is member details than cm cannot change the selected patient
    if (currentScreen !== MEMBERS_DETAILS_SCREEN_TITLE) {
      selectedMembersHandler(selectedItems);
    }
  };

  const defaultMemberSelection = () => {
    if (currentScreen === MEMBERS_DETAILS_SCREEN_TITLE) {
      selectedMembersHandler([members[0]?.patient_id]);
    }
  };

  const cancelClickHandler = () => {
    newNoteLayerHandle(false);
    if (noteEditState) {
      selectedMembersHandler([]);
      defaultMemberSelection();
      setContent(text);
      setNoteEditState(false);
      setEditMode(false);
    }
    setContent("");
    setBookmarkStatus({ isBookmarked: false });
    setRecipientType(false);
    setPrevBookmarkStatus({ isBookmarked: false });
  };

  const updateMemberList = (cc: any) => {
    if (updateMembers) {
      updateMembers(cc);
    }
  };

  const customControlData = shouldShowCustomControls
    ? {
        showCustomControls: true,
        bookmarkStatus: bookmarkStatus,
        setBookmarkStatus: setBookmarkStatus,
        recipientType: recipientType,
        setRecipientType: setRecipientType,
      }
    : {
        showCustomControls: false,
      };
  const contentLength = content.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").length;

  useEffect(() => {
    console.log("Notes.useEffect1");
    setLoaderForAllNotes(true);

    if (isAllCM) {
      selectedMembersHandler([members[0]?.patient_id]);
      setMembersOptions([
        {
          patient_id: members[0]?.patient_id,
          patient_name: members[0]?.patient_name,
        },
      ]);
      setSelectedPatientObject([{ patient_id: members[0]?.patient_id, patient_name: members[0]?.patient_name }]);
    }

    // Hight of drawer notes list
    console.log("Notes.useEffect");
    let listHeight = document.querySelector(".right-drawer .ant-drawer-body")?.clientHeight || 500;
    let headerHeight = document.querySelector(".right-drawer .ant-drawer-body .header .ant-tabs .ant-tabs-nav")?.clientHeight || 40;

    setheight(listHeight - headerHeight - 45);
  }, []);

  useEffect(() => {
    //setFilters
    const startDate = filterStartDate && filterStartDate !== "" ? filterStartDate : undefined;
    const toDate = filterEndDate && filterEndDate !== "" ? filterEndDate : undefined;
    if (searchValue?.length >= 3 || searchValue?.length === 0 || startDate !== filters.filterStartDate || toDate !== filters?.filterEndDate) {
      const filter = {
        searchBy: searchValue,
        startDate: filterStartDate,
        endDate: filterEndDate,
        isBookMarked: defaultTab === "1" ? true : false,
      };
      setFilters(filter);
      setPage(1);
      getNotesForPage(1, filter, defaultTab, true);
    }
  }, [searchValue, filterStartDate, filterEndDate]);

  const addNoteHandler = () => {
    const selectedPatient = selectedPatientObject.filter((m: any) => selectedMembers.indexOf(m.patient_id) > -1);
    if (selectedMembers && selectedMembers.length > 0) {
      setAddLoader(true);
      let reminderType = "";
      switch (currentScreen) {
        case MEMBERS_SCREEN_TITLE:
          reminderType = MEMBER_LIST_GLOBAL;
          break;
        case MEMBERS_DETAILS_SCREEN_TITLE:
          reminderType = MEMBER_DETAILS_LOCAL;
          break;
        default:
          reminderType = "";
      }
      let patients: any = [];
      membersService.addNotes(selectedMembers, content, reminderType, bookmarkStatus.isBookmarked, recipientValue).subscribe({
        next: (res) => {
          setAddLoader(false);
          newNoteLayerHandle(false);
          let savedNotes = res?.data?.data?.note;
          const old = [...members];
          const ccNote = [...copyNotes];
          patients = [...selectedPatient];
          savedNotes.forEach((ele: any) => {
            const patient = selectedPatient.filter((p: any) => p.patient_id === ele?.patientId);
            let note: any = {
              notesId: ele?.noteId || -1,
              notes: content,
              notesCreateDate: moment.utc(),
              isBookMarked: bookmarkStatus.isBookmarked,
              patientId: ele?.patientId,
              patientName: patient[0]?.patient_name,
              recipientType: recipientValue,
              careMgrFirstName: session?.user?.firstName,
              careMgrLastName: session?.user?.lastName,
            };

            // Update global notes data
            ccNote.unshift(note);
            //Updating for member table
            old.forEach((p) => {
              if (p.patient_id === ele?.patientId) {
                p.notes.unshift(note);
              }
            });
          });
          const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(USER_ACTION_DESCRIPTION_NOTE_SAVE, CASE_STATUS_REASON_NOTE);
          updateStatus(patients.length > 1 ? patients : patients[0], caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription);
          updateMemberList(old);
          selectedMembersHandler([]);
          defaultMemberSelection();
          setContent(text);
          setBookmarkStatus({ isBookmarked: false });
          setRecipientType(false);
          currentScreen !== MEMBERS_DETAILS_SCREEN_TITLE ? setSelectedPatientObject([]) : noop();
          //Notes added will be at top, moving view to top of the container
          const infiniteLoaderContainer: any = document.querySelector(".allNotes__container > div");
          if(infiniteLoaderContainer) {
            infiniteLoaderContainer.scrollTop = 0;
          }

          setPage(1);
          getNotesForPage(1, filters, defaultTab, true);
        },
        error: () => {
          setAddLoader(false);
        },
      });
    }
  };

  const editNoteHandler = () => {
    setAddLoader(true);
    let noteId = editNoteData?.notesId;
    let noteBody = content;
    if (noteId > -1) {
      membersService.editNotes(noteId, editNoteData?.patientId, noteBody, bookmarkStatus.isBookmarked, recipientValue, prevBookmarkStatus.isBookmarked).subscribe({
        next: (res) => {
          let updatedNote = res?.data?.data?.note;
          let updated = cloneDeep(notesData?.notes)?.map((item: any) => {
            return item.notesId !== noteId
              ? item
              : {
                  ...item,
                  notes: updatedNote.description,
                  patientId: updatedNote.patientId,
                  notesCreateDate: moment.utc(),
                  isBookMarked: updatedNote.isBookmarked,
                  recipientType: updatedNote.recipientType,
                };
          });

          const copyMembers = [...members];
          copyMembers.forEach((mem) => {
            if (mem.patient_id === editNoteData?.patientId) {
              mem.notes.forEach((item: any) => {
                if (item.notesId === editNoteData?.notesId) {
                  item.notes = content;
                  item.notesCreateDate = moment.utc();
                  item.isBookMarked = bookmarkStatus.isBookmarked;
                  item.recipientType = recipientValue;
                }
              });
              const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(USER_ACTION_DESCRIPTION_NOTE_UPDATE, CASE_STATUS_REASON_NOTE);
              updateStatus(mem, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription);
            }
          });
          updateMemberList(copyMembers);
          setAddLoader(false);
          setEditNoteData({});
          setNoteEditState(false);
          selectedMembersHandler([]);
          setEditMode(false);
          defaultMemberSelection();
          setContent(text);
          setBookmarkStatus({ isBookmarked: false });
          setRecipientType(false);

          if (currentScreen === MEMBERS_DETAILS_SCREEN_TITLE) {
            let tempUpdatedNotes = cloneDeep(updatedNotes);
            let isUpdatednoteExists = false;
            let tempNote = {
              notesId: editNoteData?.notesId,
              notes: updatedNote.description,
            };

            forEach(updatedNotes.editedNotes, (note, index) => {
              if (Number(note.notesId) === Number(editNoteData?.notesId)) {
                isUpdatednoteExists = true;
                tempUpdatedNotes.editedNotes[index] = {
                  ...note,
                  ...tempNote,
                };
              }
            });

            if (!isUpdatednoteExists) tempUpdatedNotes.editedNotes.push(tempNote);
            setUpdatedNotes(tempUpdatedNotes);
          }

          setNotesData({
            ...(notesData ? notesData : {}),
            bookMarkedTotalCount:
              updatedNote.prevBookmarkStatus !== updatedNote.isBookmarked
                ? updatedNote.isBookmarked
                  ? notesData?.bookMarkedTotalCount + 1
                  : notesData?.bookMarkedTotalCount - 1
                : notesData?.bookMarkedTotalCount,
            notes: updated,
          });
        },
        error: () => {
          setAddLoader(false);
        },
      });
    }
  };

  return (
    <div className="notesWrapper">
      <div className="header">
        <div className="ui-csd-legend">
          {titles.map((title, index) => (
            <Tooltip key={index} placement="bottom" title={title}>
              <div className={`ui-csd-legend__indicator ${colors[index]}`}></div>
            </Tooltip>
          ))}
        </div>
        <Tabs defaultActiveKey={defaultTab} onChange={tabsChangeHandler} size="large" className="tab-header" destroyInactiveTabPane>
          {tabs?.map((item: any) => {
            let count: any = notesData?.[item.tabCount] ? notesData?.[item.tabCount] : 0;
            return (
              <TabPane tab={`${item.name} (${count})`} key={item.key}>
                {getNotesCard(item)}
              </TabPane>
            );
          })}
        </Tabs>
      </div>

      {defaultTab === "2" ? (
        <CanEdit>
          <Button disabled={isDisabled} type="primary" shape="circle" icon={<span style={{ fontSize: "32px", top: "8%" }} className="icon-plus" />} size="large" className="addNewNote" onClick={showNewNote} />
        </CanEdit>
      ) : null}

      {showNoteLayer || noteEditState ? (
        <div className="addNewNoteContainer">
          <div className="backdrop" />
          <div className={`editorContainer ${selectedPatientObject.length > 0 && currentScreen === MEMBERS_SCREEN_TITLE ? "editorContiner-selected-members" : ""}`}>
            <h1 className="createNote-title">{noteEditState ? "Update Note" : "Create Note"}</h1>

            <div className={`memberlist-row-notes ${currentScreen === MEMBERS_DETAILS_SCREEN_TITLE || editMode ? "allowClearForNotesDisabled" : ""}`}>
              <span className="icon-users" />
              {globalPatientListLoader ? (
                <div className="memberlist-row__select-patient-loader shimmerBG" />
              ) : (
                <Select
                  // showSearch={true}
                  // currentScreen === MEMBERS_DETAILS_SCREEN_TITLE || editMode ? selectedMembers : []
                  onFocus={() => (currentScreen === MEMBERS_DETAILS_SCREEN_TITLE || editMode ? undefined : setMembersOptions([]))}
                  mode="multiple"
                  value={currentScreen === MEMBERS_DETAILS_SCREEN_TITLE || editMode ? selectedMembers : []}
                  notFoundContent={
                    fetchingPatientList ? <Spin size="small" indicator={<HealthemSpinner />} /> : membersOptions.length > 0 ? null : searchMembersInputString?.length > 3 ? <DataNotFound message={NO_DATA_FOUND} /> : null
                  }
                  placeholder="Search and Add Members"
                  className="memberlist-select"
                  // maxTagCount={2}
                  onChange={(newValue: any) => {
                    if (!(currentScreen === MEMBERS_DETAILS_SCREEN_TITLE || editMode)) {
                      // selectedMembersHandler(newValue);
                      onSelectMemberChangeHandler(newValue);
                    }
                  }}
                  filterOption={false}
                  style={{ width: "100%" }}
                  onSearch={debouncedMemberSearch}
                  //   options={options}
                  showSearch={currentScreen === MEMBERS_DETAILS_SCREEN_TITLE || editMode ? false : true}
                  // allowClear = {currentScreen === MEMBERS_DETAILS_SCREEN_TITLE || editMode ? false : true}
                  allowClear={false}
                >
                  {membersOptions &&
                    membersOptions?.map((item: any, index: any) => (
                      <Select.Option key={item.patient_id} value={item.patient_id} item={item}>
                        <div className="reminderForm__reminderContainer__body__section-3__search-members__options">
                          <div className="reminderForm__reminderContainer__body__section-3__search-members__options__avatar-container">
                            {/* <Avatar
                              className="reminderForm__reminderContainer__body__section-3__search-members__options__avatar-container__avatar"
                              style={{
                                background: index > colors.length - 1 ? colors[0] : colors[index],
                              }}
                            >
                              {item?.patient_name?.charAt(0)}
                            </Avatar> */}
                            <div className="reminderForm__reminderContainer__body__section-3__search-members__options__avatar-container__name">{item?.patient_name}</div>
                          </div>
                          {item?.patient_dob ? (
                            <div className="reminderForm__reminderContainer__body__section-3__search-members__options__dob">
                              {formatDisplayDate(item?.patient_dob, "createDateFormat", "defaultDateFormat")}
                            </div>
                          ) : null}
                        </div>
                      </Select.Option>
                    ))}
                </Select>
              )}
            </div>
            {/* selectedPatientObject, setSelectedPatientObject */}
            {selectedPatientObject?.length > 0 && selectedPatientObject && currentScreen !== MEMBERS_DETAILS_SCREEN_TITLE ? (
              <div className="selected-members-for-adding-notes">
                <div className="selected-members-for-adding-notes__title">Selected Members</div>
                <div className="selected-members-for-adding-notes__container">
                  <div className="selected-members-for-adding-notes__container__list">
                    {selectedPatientObject?.map((selectedMembers: any, index: any) => {
                      return index < 2 ? (
                        <div className="selected-members-for-adding-notes__container__list__members">
                          {/* <Avatar
                            className="selected-members-for-adding-notes__container__list__members__avatar"
                            style={{
                              background: index > colors.length - 1 ? colors[0] : colors[index],
                            }}
                          >
                            {selectedMembers?.patient_name?.charAt(0)}
                          </Avatar> */}

                          <span className="selected-members-for-adding-notes__container__list__members__name">{selectedMembers?.patient_name}</span>
                          <span className="selected-members-for-adding-notes__container__list__members__close" onClick={() => onRemoveSelectedMembers(selectedMembers?.patient_id)}>
                            <Icon name={"close"} />
                          </span>
                        </div>
                      ) : null;
                    })}
                    {selectedPatientObject?.length > 2 ? (
                      <Popover content={popOverSelectedMembers}>
                        <div className="selected-members-for-adding-notes__container__list__hided-list">{selectedPatientObject?.length - 2}+</div>
                      </Popover>
                    ) : null}
                  </div>
                  <div className="selected-members-for-adding-notes__container__clearAll" onClick={() => clearAllSelectedMembers()}>
                    <CloseCircleOutlined />
                  </div>
                </div>
              </div>
            ) : null}

            <div className="editor-row">
              {/* <TextAreaComp content={content} changeHandler={setContent} actionsMenu={false} autoFocus={true} showCount={true} wordLimit={1000} /> */}
              <RichTextEditor
                editMode={editMode}
                content={content}
                changeHandler={setContent}
                customControlData={customControlData}
                actionsMenu={false}
                autoFocus={false}
                showCount={true}
                wordLimit={getNoteMaxLength()}
              />
            </div>

            <div className="newNoteFooter">
              <Button type="text" size="large" className="cancel-button" onClick={cancelClickHandler}>
                Cancel
              </Button>
              <Spin spinning={addLoader} indicator={<HealthemSpinner />}>
                <Button
                  type="primary"
                  size="large"
                  disabled={!(contentLength > 0) || contentLength > notesWordLimit || !selectedMembers.length}
                  className="f16 w500 addNoteBtn"
                  onClick={noteEditState ? editNoteHandler : addNoteHandler}
                >
                  {noteEditState ? "Update" : "Add note"}
                </Button>
              </Spin>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Notes;
